export const JWT_NAME = "ACCTK";

export const adminRole = 'sadmin'
export const cateringAdmin = 'catering.admin'
export const cateringOperator = 'catering.operator'
export const customerAdmin = 'customer.admin'
export const customerOperator = 'customer.operator'
export const customerUser = 'customer.user'
export const customerPublicUser = 'customer.user.public'